<template lang="html">
  <article class="classes" v-if="charged">

    <section class="trainers__header">
      <div class="trainers__header--title">
        <p style="width:100%">Editar {{offer.attributes.title}}</p>
        <v-breadcrumbs style="width: 100%">
          <v-icon slot="divider">chevron_right</v-icon>
          <v-breadcrumbs-item
            @click="$router.push({name: 'reward'})">
            Rewards creados
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            disabled>
            {{offer.attributes.title}}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </div>
    </section>
    <section class="trainers__create_container">
      <v-layout row wrap>
        <v-flex xs6>
          <span class="data_card__info--label">Imagen</span>
          <div class="trainers__form--photo_container">
            <label
              for="trainerPhoto"
              style="
              width: 160px;
              height: 34px;"
              class="trainers__form--photo_button">Examinar</label>
            <input
              id="trainerPhoto"
              type="file"
              @change="onFileChange"
              name="logo"
              multiple>
            <p v-if="!url_change">{{ photo_name }}</p>
          </div>
          <v-flex
            xs12
            v-if="url_change"
            class="classes__image_container">
            <div
              v-for="(image, index) in offer_photos"
              class="classes__image_container--image"
              :style="{backgroundImage: 'url('+ (image.id ? getImageServer() + image.image : image.url_image) +')'}">
              <div
                class="data_card__info--remove"
                @click="deleteImage(index)">
                <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Título</span>
            <input
              class="trainers__form--input"
              type="text"
              name="Title"
              placeholder="Título de la clase"
              v-model="offer.attributes.title">
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Descripción</span>
            <input
              class="trainers__form--input"
              type="text"
              name="Name"
              placeholder="Descripción"
              v-model="offer.attributes.description">
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Términos y condiciones</span>
            <input
              class="trainers__form--input"
              type="text"
              name="TyC"
              placeholder="Términos y condiciones generales de la clase"
              v-model="offer.attributes.tc">
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Fecha de vencimiento</span>
            <app-single-date-picker
              :date_text="offer.attributes.expiration"
              @filterQuery="changeDate($event)"></app-single-date-picker>
          </v-flex>
           <v-flex xs12>
            <span class="data_card__info--label">Categoría</span>
            <div
              class="dashboard__options--input with_box_shadow"
              style="width: 100%; margin-bottom: 20px;padding: 0">
              <select
                class=""
                style="width: 100%; height: 100%; outline: none; padding: 0 10px;"
                v-model="parent_category"
                @change="change_category = true">
                <option
                  selected="selected"
                  disabled>{{current_category != '' ? current_category.attributes.name : 'Selecciona'}}</option>
                <option
                  v-for="(category, index) in getCategories()"
                  :value="category">
                  {{category.attributes.name}}
                </option>
              </select>
              <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg">
            </div>
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Locaciones</span>
            <div
              class="dashboard__options--input with_box_shadow"
              style="width: 100%; margin-bottom: 20px;"
              @click="show_trainers_modal = true">
              <p >{{trainers_text}}</p>
              <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg">
            </div>
          </v-flex>

          <v-flex xs12>
            <v-switch
              class="data_card__switch"
              :label="`Oferta visible para los usuarios`"
              v-model="offer.attributes.published"
            ></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-switch
              class="data_card__switch"
              :label="`Se reclama con código QR`"
              v-model="offer.attributes.has_code"
            ></v-switch>
          </v-flex>
          <span v-if="has_addition" class="data_card__info--label" style="font-size:14px;">Añadir códigos a oferta</span>
          <v-flex v-if="has_addition" xs12>
            <v-switch
              class="data_card__switch"
              :label="`Múltiples códigos de canjes`"
              v-model="multicodes"
              @change="emptyCodes()"
            ></v-switch>
          </v-flex>
          <v-flex v-if="has_addition">
          <v-flex v-if="!multicodes" xs12>

            <span class="data_card__info--label">Código promocional único</span>
            <input
              class="trainers__form--input"
              type="text"
              name="Name"
              placeholder="Código promocional"
              v-model="offer.attributes.reedem_code" @change="excelTitle='';codes=[]">
            <v-flex v-if="offer.attributes.reedem_code!=null && offer.attributes.reedem_code.length>0 " >
              <span class="data_card__info--label">Límite de canjes de la oferta</span>
              <div class="data_card__counter justified">
                <span style="margin-top: 18px;" v-if="numberStaticCodes<0">{{numberStaticCodes < 0 ? 'Sin limite': numberStaticCodes}}</span>
                <input v-else
                class="trainers__form--number_input"
                type="text" @keypress="isNumber($event)"
                name="Name" :min="1" :max="1000000000"
                placeholder="Límite de canjes de la oferta"
                v-model="numberStaticCodes" @change="excelTitle=''; fillCodes();"
                >


                <div class="justified__container">
                  <div
                    class="data_card__counter--button"
                    @click="removeFromRedemption('redeem_limit')"></div>
                  <div
                    class="data_card__counter--button"
                    @click="addToRedemption('redeem_limit')"></div>
                </div>
              </div>
            </v-flex>
          </v-flex>
          <v-flex v-else>
              <span v-if="offer.attributes.has_code" class="data_card__info--label">Códigos promocionales para QR (Formato Excel)</span>
              <span v-else class="data_card__info--label">Códigos promocionales (Formato Excel)</span>
              <div class="trainers__form--photo_container">

                <label
                  for="excel_input"
                  style="
                  width: 160px;
                  height: 34px;"
                  class="trainers__form--photo_button">Examinar</label>
                <input
                  id="excel_input"
                  type="file"
                  ref="excel_input"
                  @change="excelUpload"
                  name="excel">
              </div>
            </v-flex>
            <v-flex>
              <div v-if="codes.length!=0">
                <p class="data_card__info--label">Nombre del archivo </p>
                <p style="font-size: 10px;"><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{excelTitle}}</p>
                <p class="data_card__info--label">No. códigos importados </p>
                <p  style="margin-left:27px; margin-bottom:15px;font-size: 12px;">{{codes.length }}</p>
              </div>
              <div >
                <p class="data_card__info--label" style="font-size:14px; text-decoration: underline;margin-top: 15px;">Historial de subidas </p>
                <div v-for="(file, index) in excelFiles" :key="index">
                  <p class="data_card__info--label">Número de códigos archivo #{{index+1}} </p>
                  <p style="font-size: 12px;" ><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{file}}</p>
                </div>
              </div>
            </v-flex>
          </v-flex>

          <!-- <v-flex xs12>
            <span class="data_card__info--label">Limite de canjes de la oferta</span>
            <div class="data_card__counter justified">
              <span>{{offer.attributes.redeem_limit < 0 ? 'Sin limite' : offer.attributes.redeem_limit}}</span>
              <div class="justified__container">
                <div
                  class="data_card__counter--button"
                  @click="removeFromRedemption('redeem_limit')"></div>
                <div
                  class="data_card__counter--button"
                  @click="addToRedemption('redeem_limit')"></div>
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-switch
              class="data_card__switch"
              :label="`Hacer visible`"
              v-model="offer.attributes.published"
            ></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-switch
              class="data_card__switch"
              :label="`Permitir varios canjes por usuario`"
              v-model="multi_redeemable_per_user"
            ></v-switch>
          </v-flex>
          <v-flex xs12 v-if="offer.attributes.is_multi_redeemable_per_user">
            <span class="data_card__info--label">Limite de canjes por usuario</span>
            <div class="data_card__counter justified">
              <span>{{offer.attributes.redeem_limit_per_user < 0 ? 'Sin limite': offer.attributes.redeem_limit_per_user}}</span>
              <div class="justified__container">
                <div
                  class="data_card__counter--button"
                  @click="removeFromRedemption('redeem_limit_per_user')"></div>
                <div
                  class="data_card__counter--button"
                  @click="addToRedemption('redeem_limit_per_user')"></div>
              </div>
            </div>
          </v-flex> -->
          <v-flex xs12>
            <v-switch
              class="data_card__switch"
              :label="`Oferta que es reward`"
              v-model="offer.attributes.is_rewardable"

            ></v-switch>
          </v-flex>
          <div class=""
            v-if="offer.attributes.is_rewardable">
            <v-flex xs12>
              <span class="data_card__info--label">Segmento</span>
              <div
                class="dashboard__options--input with_box_shadow"
                style="width: 100%; margin-bottom: 20px;padding: 0 10px">
                <p>{{condition.attributes.description}}</p>
              </div>
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Fecha de activación del reward</span>
              <app-single-date-picker
                @filterQuery="changeRewardDate($event, 'from')"
                :date_text="reward_attributes.from"></app-single-date-picker>
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Fecha de vencimiento del reward</span>
              <app-single-date-picker
                @filterQuery="changeRewardDate($event, 'until')"
                :date_text="reward_attributes.until"></app-single-date-picker>
            </v-flex>
          </div>
        </v-flex>
        <v-flex xs6 >
          <v-flex xs11 offset-xs1>
            <section class="data_card data_card__instance">
              <div
                class="data_card__image"
                :class = "{'without_url' : !url_change}"
                :style="{backgroundImage: 'url('+ current_image_url +')'}"></div>
              <div class="data_card__info">
                <div class="data_card__info--container">
                  <p class="data_card__info--title">
                    {{offer.attributes.title}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <p class="data_card__info--text expiration">
                    {{ offer.attributes.expiration != '' ? `Hasta ${offer.attributes.expiration}` : ''}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Descripción</span>
                  <p class="data_card__info--text full_text">
                    {{offer.attributes.description}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Términos y condiciones</span>
                  <p class="data_card__info--text full_text">
                    {{offer.attributes.tc}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Limite de canjes de la oferta</span>
                  <p class="data_card__info--text expiration">
                    {{Number(offer.attributes.redeem_limit) >= 0 ? offer.attributes.redeem_limit : 'Sin limite'}}
                  </p>
                </div>
                <!-- <div class="data_card__info--container">
                  <span class="data_card__info--label">Permitir varios canjes por usuario</span>
                  <p class="data_card__info--text classes_quantity">
                    {{offer.attributes.is_multi_redeemable_per_user == true ? 'Si' : 'No'}}
                  </p>
                </div>
                <div
                  class="data_card__info--container"
                  v-if="offer.attributes.is_multi_redeemable_per_user">
                  <span class="data_card__info--label">Limite de canjes por usuario</span>
                  <p class="data_card__info--text expiration">
                    {{Number(offer.attributes.redeem_limit_per_user) >= 0 ? offer.attributes.redeem_limit_per_user : 'Sin limite'}}
                  </p>
                </div> -->
                <v-flex xs6>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Visible para los usuarios</span>
                    <p class="data_card__info--text classes_quantity">
                      {{offer.attributes.published == true ? 'Si' : 'No'}}
                    </p>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Obtenida como reward</span>
                    <p class="data_card__info--text classes_quantity">
                      {{offer.attributes.is_rewardable == true ? 'Si' : 'No'}}
                    </p>
                  </div>
                </v-flex>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Locaciones</span>
                  <section class="data_card__info--trainers_container">
                    <div
                      class="data_card__info--trainer default_trainer"
                      v-if="locations_selected.length <= 0">
                    </div>
                    <div
                      class="data_card__info--trainer"
                      v-else
                      v-for="(trainer, index) in locations_selected"
                      :style="{backgroundImage: `url('${getImageServer() + trainer.attributes.image.thumb.url}')`}">
                      <div
                        class="data_card__info--remove"
                        @click="deleteLocation(index)">
                        <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </section>
            <div
              class="data_card__create_button"
              @click="checkForm()">
              Guardar
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </section>
    <trainers-modal
      v-if="show_trainers_modal"
      :trainers="locations"
      :selected="locations_selected"
      :title = "'Selecciona las locaciones'"
      @closeTrainersModal="closeTrainersModal($event)"
      @saveTrainers="filterSelectedTrainers($event)"></trainers-modal>
  </article>
</template>

<script>
export default {
  data(){
    return{
      current_image_url: '',
      offer: '',
      urls: [],
      locations:[],
      condition:{attributes:''},
      images: [],
      codes:[],
      excelTitle:"",
      excelFiles:[],
      has_addition:true,
      multicodes:false,
      numberStaticCodes:0,
      charged: false,
      offer_photos: [],
      locations:[],
      tags_selected: [],
      reward_attributes:{
        condition_id: null,
        from: '',
        id:'',
        until:''
      },
      parent_category:'Selecciona',
      locations_selected:[],
      current_locations: [],
      condition_selected:'Selecciona',
      url_change: false,
      photo_name: "No se han seleccionado archivos",
      trainers_text: 'Selecciona',
      show_trainers_modal: false,
      selected_trainers: [],
      multi_redeemable_per_user: false,
      current_category: '',
      change_category: false,
    }
  },
  mounted(){
    this.findCategories()
    this.findTags()
    this.findLocations()
    this.locations=this.getLocations()
    var path = this.$route.path.split('/')
    try {
      this.$http.get('rewards/'+ path[2],{headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}})
      .then(function(response){
        this.offer = response.body.data
        this.offer.offer_photos_attributes = []
        for (var i = 0; i < response.body.included.length; i++) {
          if(response.body.included[i].type == "offer_photos"){
            this.images.push(response.body.included[i])
            this.offer_photos.push({id: response.body.included[i].id, image: response.body.included[i].attributes.image.url})
          }else if(response.body.included[i].type == "locations"){
            let current_location = response.body.included[i]
            this.locations_selected.push(current_location)
            this.current_locations.push(current_location)
          }else if(response.body.included[i].type == "categories"){
            this.current_category = response.body.included[i]
            this.parent_category = response.body.included[i].attributes.name
          }else if(response.body.included[i].type == "rewards"){
            this.reward_attributes.id=response.body.included[i].id
            this.reward_attributes.condition_id=response.body.included[i].attributes.condition_id
            this.reward_attributes.from=response.body.included[i].attributes.from.substring(0,10)
            this.reward_attributes.until=response.body.included[i].attributes.until.substring(0,10)
            try {
              this.$http.get('conditions/'+response.body.included[i].attributes.condition_id,)
              .then(function(response){
                this.condition = response.body.data
              }, function(response){
                if(typeof response.body.errors[0].details != "object"){
                  alert(response.body.errors[0].details);
                }else{
                  let message = []
                  for(var key in response.body.errors[0].details){
                    message.push(response.body.errors[0].details[key])
                  }
                  alert(message);
                }
              })
            } catch (e) {
              alert(e.message)
            }
          }else if(response.body.included[i].type == "categories"){
            this.current_category = response.body.included[i]
            this.parent_category = response.body.included[i].attributes.name
          }
        }

        if(this.locations_selected.length>0){
          this.trainers_text = this.locations_selected.length > 1 ? `${this.locations_selected.length} seleccionados` : `${this.locations_selected.length} seleccionado`
        }

        if(this.offer_photos.length > 0){
          this.current_image_url = this.getImageServer() + this.offer_photos[0].image
          this.url_change = true
        }
        this.offer.location_offers_attributes = []

        this.multi_redeemable_per_user = this.offer.attributes.is_multi_redeemable_per_user
        if(this.multi_redeemable_per_user == false){
          this.charged = true
        }
        this.excelFiles=response.body.meta.files;
        var my_files=[]
        for(var element in this.excelFiles) {
          my_files.push(this.excelFiles[element]);
        };
        this.excelFiles=my_files;

        if (my_files.length>0 && this.offer.attributes.redeem_limit>=0){
          this.offer.attributes.reedem_code=null;
          this.multicodes=true;
        }
        this.offer.attributes.has_code=!this.offer.attributes.has_code;
        if(this.offer.attributes.redeem_limit<0){
          this.multicodes=false;
          this.has_addition=false;
        }
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }

  },
  watch:{
    multi_redeemable_per_user(){
      if(this.charged == true){
        this.offer.attributes.is_multi_redeemable_per_user = this.multi_redeemable_per_user
        if(this.multi_redeemable_per_user == true){
          if(this.offer.attributes.redeem_limit_per_user != null){
            this.offer.attributes.redeem_limit_per_user = -1
          }
        }else {
          this.offer.attributes.redeem_limit_per_user = 1
        }
      }
      this.charged = true;
    },
  },
  methods: {

     isNumber(event){
      var keycode= event.keyCode
      var ans=true;
      if(keycode<48 || keycode>57){
        event.preventDefault();
        ans=false;
      }

      return ans;
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      for (var i = 0; i < files.length; i++) {
        // this.offer.offer_photo_attributes.push({id: null, url_image: URL.createObjectURL(files[i])});
        this.createImage(files[i])
      }
    },
    emptyCodes(){
      if(this.multicodes){
        this.numberStaticCodes=0;
        this.offer.attributes.reedem_code=null;
      }else{
        this.codes=[];
        this.excelTitle="";
      }
    },
    scanForNews(){
      for (var i = 0; i < this.locations_selected.length; i++) {
        var found = false;
        var j=0;
        var a = ""
        while (!found && j < this.current_locations.length){
          if(this.locations_selected[i].id==this.current_locations[j].id){
            found=true;
            a=this.locations_selected[i].id
          }
          j++;
        }
        if(!found){
          this.offer.location_offers_attributes.push({location_id: this.locations_selected[i].id})
        }
      }
    },
    scanForDeleteds(){
      for (var i = 0; i < this.current_locations.length; i++) {
        var found = false;
        var j=0;
        var a = ""
        while (!found && j < this.locations_selected.length){
          if(this.current_locations[i].id==this.locations_selected[j].id){
            found=true;
          }
          j++;
        }
        if(!found){
          for (var j = 0; j < this.offer.attributes.location_offers.length; j++) {
            if(this.offer.attributes.location_offers[j].location_id == this.current_locations[i].id){
              this.offer.location_offers_attributes.push({id: this.offer.attributes.location_offers[j].id, _destroy: this.offer.attributes.location_offers[j].id})
            }
          }
        }
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.offer_photos.push({url_image: URL.createObjectURL(file), image: reader.result, _destroy: ''})
        vm.current_image_url = vm.offer_photos[0].id ? vm.getImageServer() + vm.offer_photos[0].image : vm.offer_photos[0].url_image
      }
    },
    deleteImage(index){
      if(this.offer_photos[index].id != undefined && this.offer_photos[index].id != null){
        this.offer_photos[index]._destroy = this.offer_photos[index].id
        this.offer.offer_photos_attributes.push({id: this.offer_photos[index].id, _destroy: this.offer_photos[index]._destroy})
      }
      this.offer_photos.splice(index, 1)
      this.current_image_url = this.offer_photos[0].id ? this.getImageServer() + this.offer_photos[0].image : this.offer_photos[0].url_image
    },
    deleteLocation(index){
      // if(this.locations_selected[index].id != undefined && this.locations_selected[index].id != null){
      //   for (var i = 0; i < this.offer.attributes.location_offers.length; i++) {
      //     if(this.offer.attributes.location_offers[i].location_id == this.locations_selected[index].id){
      //       this.offer.location_offers_attributes.push({id: this.offer.attributes.location_offers[i].id, _destroy: this.offer.attributes.location_offers[i].id})
      //     }
      //   }
      // }
      // this.current_locations.splice(index, 1)
      this.locations_selected.splice(index, 1)
    },
    excelUpload(){
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if (regex.test(fileUpload.value.toLowerCase())) {
          var vm=this;

          if (typeof (FileReader) != "undefined") {
              var reader = new FileReader();
              vm.excelTitle=fileUpload.files[0].name;
              //For Browsers other than IE.
              if (reader.readAsBinaryString) {
                  reader.onload = function (e) {
                      vm.ProcessExcel(e.target.result);
                  };
                  reader.readAsBinaryString(fileUpload.files[0]);
              } else {
                  //For IE Browser.
                  reader.onload = function (e) {
                      var data = "";
                      var bytes = new Uint8Array(e.target.result);
                      for (var i = 0; i < bytes.byteLength; i++) {
                          data += String.fromCharCode(bytes[i]);
                      }
                      vm.ProcessExcel(data);
                  };
                  reader.readAsArrayBuffer(fileUpload.files[0]);
              }
          } else {
              // alert("This browser does not support HTML5.");
              vm.updateAlertMessage("This browser does not support HTML5.");
              vm.updateIsInAlert(true);
          }
      } else {
          // alert("Por favor subir un archivo de códigos válido (Formato Excel).");
          vm.updateAlertMessage("Por favor subir un archivo de códigos válido (Formato Excel).");
          vm.updateIsInAlert(true);
      }
    },
    ProcessExcel(data) {
      //Read the Excel File data.
        var workbook = XLSX.read(data, {
            type: 'binary'
        });

      //Fetch the name of First Sheet.
        var firstSheet = workbook.SheetNames[0];

        //Read all rows from First Sheet into an JSON array.
        var excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet],{header:["data"]});
        var codes=[]
        for(var row in excelRows){
          codes.push(excelRows[row]["data"]);
        }
        this.codes=codes;
        this.offer.attributes.redeem_limit=this.codes.length;
    },
    checkForm: function(e) {
      for (var i = 0; i < this.offer_photos.length; i++) {
        if(this.offer_photos[i].id == null){
          // this.offer.offer_photo_attributes.push(this.offer_photos[i])
          this.offer.offer_photos_attributes.push({image: this.offer_photos[i].image})
        }
      }

      if(this.offer_photos.length>0){
        if(this.offer.attributes.title.length>0 && this.offer.attributes.description.length>0
        && this.offer.attributes.tc.length>0 && this.offer.attributes.expiration.length>0 ){
            if(this.locations_selected.length>0){
              if (this.parent_category != null && this.parent_category != "Selecciona") {

                this.scanForNews()
                this.scanForDeleteds()
                if (this.parent_category != null && this.parent_category != 'Selecciona' && this.change_category) {
                  this.offer.attributes.object_categories_attributes = []
                  var category = {category_id: this.parent_category.id, categorizable_type: 'Offer'}
                  this.offer.attributes.object_categories_attributes.push(category)
                  // this.offer.attributes.category_ids = [this.parent_category.id]
                }
                if (this.tags_selected.length > 0) {
                  this.offer.attributes.object_tags_attributes = []
                  for (var i = 0; i < this.tags_selected.length; i++) {
                    // if(this.tags_selected[i].delete == true){
                    //   var tag = { id: this.tag_sended[i].object_tag_id,
                    //               tag_id: this.tag_sended[i].id,
                    //               taggable_type: 'Product',
                    //               taggable_id: this.instance.id,
                    //               _destroy:  this.tag_sended[i].id
                    //             }
                    // } else {
                      var tag = { tag_id: this.tags_selected[i].id,
                                  taggable_type: 'Offer'
                                }
                    // }
                    this.offer.attributes.object_tags_attributes.push(tag)
                  }
                }
                if(this.offer.attributes.is_rewardable){
                  this.is_valid=true;
                  // if(this.offer.reward_attributes.condition_id != null &&
                  //   this.offer.reward_attributes.from != '' &&
                  //   this.offer.reward_attributes.from != ''){
                  //   this.is_valid = true
                  // }else{
                  //   this.is_valid = false
                  // }
                }else{
                  this.$delete(this.offer, 'reward_attributes')
                  this.is_valid = true
                }

                try {
                  var path = this.$route.path.split('/')
                  if(this.offer.attributes.is_rewardable){
                    this.offer["reward_attributes"]=this.reward_attributes
                  }else{
                    this.offer["reward_attributes"]={
                                                      condition_id: null,
                                                      from: '',
                                                      id:'',
                                                      until:''
                                                    }
                  }
                  if(!this.multicodes && this.numberStaticCodes>=0 ){
                        var myCodes=[];
                        for( let i=0; i<this.numberStaticCodes; i++){
                          myCodes.push(this.offer.attributes.reedem_code);
                        }
                        this.codes=myCodes;
                  }
                  if(this.codes.length>0){
                    this.offer["codes"]=this.codes;
                    this.offer.attributes.redeem_limit=this.redemtions_limit;
                  }
                  else if(this.offer.attributes.redeem_limit<0){
                    this.offer.attributes.redeem_limit=-1;
                  }

                  this.offer.attributes.has_code=!this.offer.attributes.has_code;
                  var offerJson =this.offer;
                  this.$http.patch('offers/'+ this.offer.id, {data: this.encrypt(offerJson).toString()},
                    {headers:
                      {"X-Device-ID" : this.getDeviceId(),
                      "Authorization" : 'Bearer ' + this.getUserToken()}})
                  .then(function(response){
                    this.$router.push({name: 'reward'})

                    if(response.body.meta != undefined && response.body.meta != null){
                      if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                      }
                    }
                  }, function(response){
                    if(response.body.meta != undefined && response.body.meta != null){
                      if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                      }
                    }
                    if(typeof response.body.errors[0].details != "object"){
                      alert(response.body.errors[0].details);
                    }else{
                      let message = []
                      for(var key in response.body.errors[0].details){
                        message.push(response.body.errors[0].details[key])
                      }
                      alert(message);
                    }
                  })
                } catch (e) {
                  alert(e.message)
                }
              }else {
                alert('Cada oferta debe tener mínimo una categoría ');
              }
            }else {
              alert('Cada oferta debe tener mínimo una locación');
            }
        }else {
          alert('Debes completar todos los campos antes de enviar la oferta');
        }
      } else {
        alert('Debes adjuntar al menos una imagen para la oferta');
      }

    },
    changeDate(val){
      this.offer.attributes.expiration = val
    },
    closeTrainersModal(val){
      this.show_trainers_modal = val
    },
    filterSelectedTrainers(val){
      this.locations_selected = val
      this.trainers_text = val.length > 1 ? `${val.length} seleccionados` : `${val.length} seleccionado`
      this.show_trainers_modal = false;
    },
    addToRedemption(object){
      if(object=="redeem_limit"){
        this.numberStaticCodes=Number(this.numberStaticCodes)+1;
      }
      this.offer.attributes[object] = Number(this.offer.attributes[object]) + 1
    },
    removeFromRedemption(object){
      if(object=="redeem_limit"){
        if(Number(this.numberStaticCodes)>0){
          this.numberStaticCodes=Number(this.numberStaticCodes)-1;
        }
      }
      if(Number(this.offer.attributes[object]) >= 0){
        //Esta linea es cuando se puedan los códigos infinitos
        //this.offer.attributes[object] = Number(this.offer.attributes[object]) - 1
        this.offer.attributes[object]=0;
      }
    },
    changeRewardDate(val, context){
      this.reward_attributes[context] = val
    },
  },
  computed:{

    redemtions_limit(){
      var sum=0;
      sum=-this.offer.attributes.redeem_count;
      if(this.offer.attributes.redeem_limit>=0){
        for(var element in this.excelFiles) {
          sum+=Number(this.excelFiles[element]);
        };
        if(this.codes.length>0){
          sum+=this.codes.length;
        }
        else if(this.numberStaticCodes>0){
          sum+=Number(this.numberStaticCodes);
        }
        this.offer.attributes.redeem_limit=sum;
      }else{sum=-1}
      return sum;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/rewards/Edit_reward.vue